import { Component, Input } from "@angular/core"
import { CardMetaComponent } from "../card-meta.component"

@Component({
    selector: "app-search-card-meta",
    templateUrl: "./search-card-meta.component.html",
    styleUrls: ["./search-card-meta.component.scss"],
})
export class SearchCardMetaComponent extends CardMetaComponent {
    @Input() public gtmDataCardNumber: number
    @Input() public gtmPrefix: string
}
